import { $t } from '@/i18n';
import { runtimeInfo } from '@/utils/fetch';
import logger from '@/utils/logger';
import { shallowObj } from '@/utils/object';
import { computed, inject } from '@vue/composition-api';
import { isMatch } from 'lodash';
import qs from 'query-string';
import { useRouter } from '@/router/useRouter';
export function useBaseInfo() {
    const w = inject('w', {});
    const routerData = useRouter();
    const { router: $router } = routerData;
    const $route = computed(() => {
        const $route = routerData.route.value;
        const $router = routerData.router.value;
        let finalRoute = $route;
        try {
            // 无权限时根据重定向的 url 字段模拟路由选中菜单
            const { page403Path, page403Query: page403QueryStr } = runtimeInfo();
            const currentQuery = $route?.query || {};
            const page403Query = qs.parse(page403QueryStr)?.query || {};
            if ($route?.path === page403Path && $route?.query?.url && isMatch(currentQuery, page403Query)) {
                const url = new URL(currentQuery.url);
                const base = $router?.options?.base;
                const path = url.href.replace(url.origin, '').replace(base, '');
                const mockRoute = $router?.resolve(path);
                if (mockRoute?.resolved) {
                    finalRoute = mockRoute.route;
                }
            }
        }
        catch (err) {
            logger.error($t('k_df44eb0c'), err);
        }
        finally {
            return finalRoute;
        }
    });
    const stringInteropContext = computed(() => ({
        ...(w?.mainRenderer ?? {}),
        $app: w?.$app,
        w,
    }));
    const options = computed(() => shallowObj({ stringInteropContext, $route, $router }));
    return {
        options,
        $route,
    };
}
